module.exports = __webpack_public_path__ + "static/media/images_section_img1.99eb06f2.png";